export default __webpack_public_path__ + "static/media/stat3.8fe5698e.svg";